import { CSSProperties, ReactNode } from 'react'

import { Stack, Paper } from '@mui/material'

import { Field } from './components/Field'
import { FieldHeader } from './components/FieldHeader'

import { CustomFieldOption } from '../../../../types'

import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

const MainPaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: 1,
}

type Props = {
  label: string
  testId?: string
  value: Record<string, string>
  disabled: boolean
  error: boolean
  helperText: ReactNode
  onChange: (value: Record<string, string>) => void
  options: CustomFieldOption[]
  maxSelectionsCount?: number
}

export function CustomFieldInput(props: Props) {
  const {
    label,
    testId = 'customFields-list-field',
    value,
    disabled,
    onChange,
    options,
    maxSelectionsCount,
    helperText,
    error,
  } = props

  const actions = useActions(value, onChange)

  const texts = useTexts()

  const hasCustomFields = Object.keys(value).length > 0
  const hasMaxedTagsReached =
    maxSelectionsCount !== undefined && Object.keys(value).length >= maxSelectionsCount

  return (
    <Stack data-testid={testId} data-trackid={testId} gap={2}>
      <FieldHeader
        fieldLabel={label}
        testId={`${testId}-section-header`}
        action={{
          onClick: actions.onAddCustomField,
          disabled: hasMaxedTagsReached || disabled,
          label: texts.addCustomField,
          tooltip: hasMaxedTagsReached
            ? texts.maxCustomFieldsReached(maxSelectionsCount)
            : texts.addCustomField,
        }}
      />
      {hasCustomFields && (
        <Paper elevation={0} sx={MainPaperStyle}>
          <Field
            onUpdateSelect={actions.onUpdateSelect}
            onRemove={actions.onRemoveCustomField}
            value={value}
            disabled={disabled}
            onUpdateValue={actions.onUpdateValue}
            options={options}
            error={error}
            errorText={helperText}
          />
        </Paper>
      )}
    </Stack>
  )
}
